import React, { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { toast } from "react-hot-toast";
import { AxiosError } from "axios";
import { sendSupportEmail } from "../../api/mail";
import { MdArrowBack } from "react-icons/md";


export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      await sendSupportEmail({
        subject: "RPM Marketplace - Password Reset Request",
        body: "This email has requested a reset request. Respond to them.",
        sender_email: email,
        admin_email: null
      });
      toast.success(
        "Request sent successfully, we will get back to you as soon as possible!"
      );
      // navigate("/login");
    } catch (err: unknown) {
      const error = err as AxiosError<{ detail?: string; message?: string }>;
      const msg =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Email failed to send";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen w-full relative">
      <div className="absolute inset-0 z-0 grid grid-cols-1 lg:grid-cols-2">
        <div className="hidden lg:block bg-[#FF7A1A]"></div>
        <div className="bg-[#F3F4F6]"></div>
      </div>

      {/* Login card as second layer, centered over both halves */}
      <div className="relative z-10 min-h-screen flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md bg-white rounded-3xl shadow-[0_12px_40px_rgba(0,0,0,0.12)] p-8 sm:p-10">
          {/* Title with back arrow */}
          <h1 className="text-2xl font-semibold text-[#606060] mb-7 text-center relative">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="absolute left-0 top-1/2 -translate-y-1/2 text-[#FF7A1A] hover:text-[#e56f16] font-medium"
            >
              <MdArrowBack size={24} />
            </button>
            Forgot Password
          </h1>
          <form onSubmit={onSubmit} className="space-y-6">
            {/* Email */}
            <label className="block">
              <span className="block text-sm font-medium text-[#606060] mb-2">
                Email address
              </span>
              <div className="relative bg-[#EEF1F5] rounded-2xl overflow-hidden ring-1 ring-transparent focus-within:ring-orange-300 transition">
                <input
                  type="email"
                  required
                  className="w-full bg-transparent pl-4 pr-12 py-4 outline-none text-[#303030] placeholder:text-[#9aa3ae]"
                  placeholder="alex@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-label="Email address"
                  autoComplete="email"
                />
                <MdEmail
                  size={22}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9aa3ae] pointer-events-none"
                />
              </div>
            </label>

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-[#FF7A1A] hover:bg-[#e56f16] disabled:opacity-60 disabled:cursor-not-allowed text-white rounded-2xl py-4 text-lg font-semibold shadow-md transition transform active:scale-[0.99]"
            >
              {submitting
                ? "Sending Reset Request..."
                : "Request Password Reset"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
